import { action } from 'typesafe-actions';
import { GiroWebappError } from '../../../model/error';
import { UserSimple, UserToChangePassword } from '../../../model/user';
import { ChangePasswordActionTypes } from './types';

export const changePasswordRequest = (request: UserToChangePassword) => action(ChangePasswordActionTypes.CHANGE_PASSWORD_REQUEST, request);
export const changePasswordSuccess = (user: UserSimple) => action(ChangePasswordActionTypes.CHANGE_PASSWORD_SUCCESS, user);
export const changePasswordError = (error: GiroWebappError) => action(ChangePasswordActionTypes.CHANGE_PASSWORD_ERROR, error);
export const changePasswordResetState = () => action(ChangePasswordActionTypes.CHANGE_PASSWORD_RESET_STATE);
